import request from './http'
import { CREDITOS_ENDPOINT } from '../infrastructure/appConstants'

const creditoService = {
  listCreditos: () => request.get(`${CREDITOS_ENDPOINT}/credito/listar`),
  creditoDetail: (req) => request.post(`${CREDITOS_ENDPOINT}/credito/obtener`, req),
  listCuotas: (req) => request.post(`${CREDITOS_ENDPOINT}/cuota/listar`, req)
}

export default creditoService
